import React from 'react';
import PropTypes from 'prop-types';

const SvgImage = ({ active, ...props }) => {
    const strokeColor = active ? '#ffffff' : '#343A72';
    const fillColor = active ? '#7AB3B3' : '#EAEBF0';
    const color = active ? '#128383' : '#fff';
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="none" viewBox="0 0 26 26" {...props}>
            <path
                fill={color}
                fillRule="evenodd"
                stroke={strokeColor}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.25"
                d="M24.528 1.672v14.453l-3.361-1.68-3.361 1.68-10.084-5.042L1 14.444V1.672c0-.37.302-.672.672-.672h22.184c.37 0 .672.302.672.672Z"
                clipRule="evenodd"
            />
            <path
                fill={color}
                fillRule="evenodd"
                stroke={strokeColor}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.25"
                d="M19.15 8.394v0a2.017 2.017 0 1 1 0-4.033 2.017 2.017 0 0 1 0 4.033Zm5.378 7.731v3.361l-6.722-3.361 3.36-1.68 3.362 1.68Z"
                clipRule="evenodd"
            />
            <path
                fill={fillColor}
                fillRule="evenodd"
                d="M24.528 19.486v4.37c0 .37-.303.672-.672.672H1.672A.674.674 0 0 1 1 23.856v-9.412l6.722-3.36 16.806 8.402Z"
                clipRule="evenodd"
            />
            <path
                stroke={strokeColor}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.25"
                d="M24.528 19.486v4.37c0 .37-.303.672-.672.672H1.672A.674.674 0 0 1 1 23.856v-9.412l6.722-3.36 16.806 8.402Z"
                clipRule="evenodd"
            />
        </svg>
    );
};
SvgImage.propTypes = {
    active: PropTypes.bool,
};
SvgImage.defaultProps = {
    active: false,
};

export default SvgImage;
